// extracted by mini-css-extract-plugin
export var actions = "_4s-0";
export var actionsContainer = "_4s-7";
export var border = "_4s-1";
export var childFullHeight = "_4s-f";
export var collapse = "_4s-2";
export var content = "_4s-a";
export var contentChild = "_4s-e";
export var fullscreen = "_4s-c";
export var hasLeftRadius = "_4s-k";
export var headerContainer = "_4s-3";
export var headerRow = "_4s-5";
export var hidePadding = "_4s-b";
export var navCollapsedGap = "_4s-l";
export var noScrollX = "_4s-m";
export var noScrollY = "_4s-n";
export var noTopPadding = "_4s-i";
export var optOutTopPadding = "_4s-d";
export var pageMain = "_4s-j";
export var pageOuter = "_4s-g";
export var pagePadding = "_4s-8";
export var pageScroll = "_4s-9";
export var profile = "_4s-o";
export var profileContainer = "_4s-p";
export var profileImage = "_4s-q";
export var profileMain = "_4s-r";
export var profileSubtitle = "_4s-t";
export var profileTitle = "_4s-s";
export var showLeftPadding = "_4s-h";
export var tabsPortalSlot = "_4s-6";
export var tabsWrapper = "_4s-4";
export var title = "_4s-u";